/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SearchLoupeMinusIcon32Regular = forwardRef('SearchLoupeMinusIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M10 14a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H10Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.5 15C2.5 8.096 8.096 2.5 15 2.5S27.5 8.096 27.5 15a12.45 12.45 0 0 1-2.982 8.104l6.19 6.189a1 1 0 0 1-1.415 1.414l-6.19-6.19A12.45 12.45 0 0 1 15 27.5C8.096 27.5 2.5 21.904 2.5 15ZM15 4.5C9.201 4.5 4.5 9.201 4.5 15S9.201 25.5 15 25.5 25.5 20.799 25.5 15 20.799 4.5 15 4.5Z" })));
});
